export default "__VITE_ASSET__O6am63mM__"